/**
 * Legacy internal tokens (`{{ref:<targetId>}}`) splice the TARGET block's id
 * into the token, not the reference row's id — so the same token id is shared
 * by every reference row that points at that target. Registering this key
 * alongside the plain target-id key lets a chip look itself up by
 * (source block, target token) instead of colliding with whichever row for
 * that target happened to be processed first.
 */
export function buildSourceScopedRefKey(
  sourceBlockId: string,
  tokenId: string,
): string {
  return `${sourceBlockId}::${tokenId}`;
}
